// 英文译文 · 供应商库 / 来货价 / 供应商合同 / 客户库 / 货代库 · key = 代码里的中文原文,一字不差
export default {
  // ── 通用(本模块) ──
  "全部": "All",
  "全部类型": "All types",
  "全部供应商": "All suppliers",
  "搜编号/名称": "Search code / name",
  "必填": "Required",
  "无变化": "No changes",
  "name 必填": "Name is required",
  "简称": "Short Name",
  "联系人": "Contact",
  "主联系人": "Primary Contact",
  "姓名": "Name",
  "电话": "Phone",
  "结算": "Billing",
  "默认币": "Default Currency",
  "选或输入": "Select or type",
  "选或输入自定义": "Select or type a custom value",
  "选国家 or 输 ISO-2": "Select a country or type an ISO-2 code",
  "状态原因": "Status Reason",
  "冻结": "Blocked",
  "生效中": "Active",
  "生效止": "Effective until",
  "已被替代": "Superseded",
  "待 {name} 审批": "Awaiting approval by {name}",
  "保存草稿": "Save Draft",
  "内部": "Internal",
  "关联": "Affiliate",
  "内部关联": "Internal Affiliate",
  "内部关联公司": "Internal Affiliate Company",
  "内部公司代号": "Internal Company Code",
  "选公司 slug": "Select company slug",
  "勾选 = 平台上另一家 tenant 公司 · 用于跨公司交易": "On = another tenant company on this platform · used for inter-company transactions",
  // ── 供应商库 ──
  "供应商列表": "Supplier List",
  "供应商档案 · 来货价审批工作流": "Supplier profiles · Supplier price approval workflow",
  "新建供应商": "New Supplier",
  "编辑供应商": "Edit Supplier",
  "返回供应商库": "Back to Suppliers",
  "供应商名": "Supplier Name",
  "币 / 付款": "Cur. / Terms",
  "概览": "Overview",
  "国家 code": "Country Code",
  "来货价 ({n})": "Supplier Prices ({n})",
  "来货价 · 审批": "Supplier Prices · Approval",
  // ── 来货价 ──
  "供应商来货价 · 审批工作流": "Supplier Prices · Approval Workflow",
  "新建来货价(draft)": "New Supplier Price (draft)",
  "新建来货价(草稿)": "New Supplier Price (Draft)",
  "待复核": "Pending Review",
  "搜产品编号": "Search product code",
  "产品名": "Product Name",
  "起订": "MOQ",
  "起订量": "Min. Order Qty",
  "复核人": "Reviewer",
  "输入编号/名称搜": "Type code / name to search",
  "报价有效期至": "Quote Valid Until",
  "已保存草稿": "Draft saved",
  "提交 {code} 的价格 {price} 进入审核?": "Submit the price {price} for {code} for review?",
  "已提交待复核": "Submitted for review",
  "确认通过 {code} 的价格 {price}?": "Approve the price {price} for {code}?",
  "双人复核铁律:你不能是提交人({name})": "Four-eyes rule: you cannot be the submitter ({name})",
  "复核通过": "Approve",
  "已通过": "Approved",
  "驳回必填意见": "A comment is required to reject",
  "驳回意见": "Rejection Comment",
  "驳回 {code} 的价格 {price}": "Reject the price {price} for {code}",
  "必填 · 说明为什么驳回": "Required · explain why it is rejected",
  // ── 供应商合同 ──
  "合同": "Contract",
  "供应商合同": "Supplier Contracts",
  "搜合同号/主题": "Search contract no. / title",
  "已到期": "Expired",
  "已终止": "Terminated",
  "30 天内到期": "Expiring within 30 days",
  "新建合同": "New Contract",
  "新建合同 (draft)": "New Contract (draft)",
  "合同号": "Contract No.",
  "主题": "Title",
  "有效期": "Validity",
  "年最小承诺": "Min. Annual Commitment",
  "年最小采购承诺": "Min. Annual Purchase Commitment",
  "提交审批": "Submit for Approval",
  "批准": "Approve",
  "新签替代": "Supersede",
  "终止": "Terminate",
  "合同头": "Contract Header",
  "外部合同号": "External Contract No.",
  "供应商侧编号": "Supplier's reference no.",
  "签署日期": "Signed Date",
  "自动续约": "Auto Renewal",
  "续约前提醒(天)": "Renewal Notice (days)",
  "到期自动续 · 关闭 = 到期需人工操作": "Renews automatically on expiry · Off = manual action required on expiry",
  "Net 30 / 预付 30% + 余款月结": "Net 30 / 30% Prepaid + balance monthly",
  "Net 30 / 预付 30%": "Net 30 / 30% Prepaid",
  "合同行 + 量价阶梯": "Contract Lines + Price Tiers",
  "添加行": "Add Line",
  "无合同行": "No contract lines",
  "搜产品编号/名称": "Search product code / name",
  "单位 pcs": "Unit, e.g. pcs",
  "交期天": "Lead days",
  "删行": "Remove Line",
  "量价阶梯:": "Price tiers:",
  "量价阶梯": "Price tiers",
  "档": "Tier",
  "档 {n}": "Tier {n}",
  "起订量 ≥": "Min qty ≥",
  "保存改动": "Save Changes",
  "附件": "Attachments",
  "文件链接/路径": "File Link / Path",
  "上传人": "Uploaded By",
  "删": "Delete",
  "scan(扫描件)": "Scan",
  "amendment(修订)": "Amendment",
  "termination(终止)": "Termination",
  "other(其他)": "Other",
  "file_ref (对象存储 key 或 URL)": "file_ref (object storage key or URL)",
  "加附件": "Add Attachment",
  "变更日志 · 最近 10 条": "Change Log · Last 10",
  "意见": "Comment",
  "终止合同": "Terminate Contract",
  "终止原因": "Termination Reason",
  "新签替代 · supersede": "Supersede",
  "选择一份同供应商下已激活的合同作为替代 · 本合同将标记为 superseded": "Select an active contract from the same supplier as the replacement · this contract will be marked as superseded",
  "替代合同": "Replacement Contract",
  "替换": "Replace",
  "请选择供应商": "Please select a supplier",
  "请填合同主题": "Please enter the contract title",
  "至少 1 条合同行": "At least 1 contract line is required",
  "已创建 · draft 状态": "Created · status: draft",
  "提交本合同进入审批?": "Submit this contract for approval?",
  "确认批准本合同?": "Approve this contract?",
  "双人复核铁律:你不能是起草人({name})": "Four-eyes rule: you cannot be the drafter ({name})",
  "已批准 · 合同价已物化到 cost_price": "Approved · contract prices written to cost_price",
  "已批准 · 合同价已生效 · 替代旧来货价 {n} 条": "Approved · contract prices active · {n} old cost prices superseded",
  "处理中 · 合同行多时要等一会儿,请勿重复点击": "Processing · large contracts take a moment, please don't click again",
  "驳回必填理由": "A reason is required to reject",
  "终止必填理由": "A reason is required to terminate",
  "已终止 · 关联 cost_price 已 paused": "Terminated · linked cost_price entries paused",
  "请选择替代合同": "Please select the replacement contract",
  "旧合同已被替换": "The old contract has been superseded",
  "旧合同已被替换 · 新合同里没有的 {n} 个产品,来货价已暂停": "The old contract has been superseded · cost prices paused for {n} products not in the new contract",
  "file_ref 和 display_name 必填": "file_ref and display_name are required",
  "附件已加": "Attachment added",
  "删除该附件?": "Delete this attachment?",
  // ── 客户库 ──
  "新建客户": "New Customer",
  "编辑客户": "Edit Customer",
  "授信": "Credit",
  "授信额度": "Credit Limit",
  "超期告警(天)": "Overdue Alert (days)",
  "父客户 ID": "Parent Customer ID",
  "分站": "Sub-channel",
  "分站 code": "Sub-channel Code",
  "主联系人(快照)": "Primary Contact (snapshot)",
  "省": "Province / State",
  "市": "City",
  "地址 1": "Address 1",
  "地址 2": "Address 2",
  "邮编": "Postal Code",
  "收货电话": "Shipping Phone",
  "基础": "Basics",
  "联系人 ({n})": "Contacts ({n})",
  "新增联系人": "Add Contact",
  "编辑联系人": "Edit Contact",
  "主联": "Primary",
  "主": "Primary",
  "设为主联": "Set as Primary",
  "采购/财务/物流/售后": "Purchasing / Finance / Logistics / After-sales",
  "删除联系人 {name}?": "Delete contact {name}?",
  // ── 货代库 ──
  "货代主数据 · 费率维护 · 询价工具": "Forwarder master data · Rate maintenance · Quote tool",
  "新建货代": "New Forwarder",
  "编辑货代": "Edit Forwarder",
  "优先级": "Priority",
  "加收比": "Markup",
  "费率": "Rates",
  "先在【货代】tab 里点某个货代的【费率】按钮": "First click a forwarder's \"Rates\" button on the \"Forwarder\" tab",
  "新建费率": "New Rate",
  "试算运费": "Estimate Shipping",
  "计费": "Pricing",
  "起步 {g}g / {currency} {price}": "First {g}g / {currency} {price}",
  "增量 {g}g / {currency} {price} 段": "Each additional {g}g / {currency} {price}",
  "附加": "Surcharges",
  "燃油 {pct}%": "Fuel {pct}%",
  "偏远 {amount}": "Remote {amount}",
  "云途/联邦 FedEx/EMS/DHL": "Yuntu / FedEx / EMS / DHL",
  "默认货代": "Default Forwarder",
  "默认 0.1 = 加收 10%": "Default 0.1 = 10% markup",
  "货代的英文代号,比如云途填 yuntu · 本公司里不能重复 · 系统不会拿它自动调货代接口,运单号还是手工填": "Short English code for the forwarder, e.g. yuntu for YunExpress · must be unique within the company · not used to call the forwarder's API; waybill numbers are still entered by hand",
  "数字越小越靠前,最高是 1 · 只影响列表和下拉框里的排列顺序,不会自动选货代": "Smaller numbers come first; the highest is 1 · only affects the order in lists and dropdowns, does not pick a forwarder automatically",
  "生成发货单时自动选上它 · 一家公司只能有一个默认,打开这个会把别的默认关掉": "Pre-selected when creating a shipment · only one default per company; turning this on turns off the others",
  "默认 0.1 = 加收 10% · 只在「费率 → 询价」算给客户的运费报价时用(成本 × 1.1),不影响发货": "Default 0.1 = 10% markup · only used by Rates → Quote to price freight for customers (cost × 1.1); does not affect shipping",
  "同 (渠道 + 国家) 只允许一条 active · 新费率提交后旧的自动 supersede": "Only one active rate per (channel + country) · once a new rate is saved, the old one is superseded automatically",
  "渠道产品线": "Channel Product Line",
  "目的国 (ISO-2)": "Destination (ISO-2)",
  "US / DE / * (兜底)": "US / DE / * (fallback)",
  "起步克数": "First Weight (g)",
  "起步价": "First Weight Price",
  "增量克数(每段)": "Step Weight (g per step)",
  "每段增量单价": "Price per Step",
  "燃油附加(%)": "Fuel Surcharge (%)",
  "偏远附加": "Remote Area Surcharge",
  "保存费率": "Save Rate",
  "目的国": "Destination",
  "计算": "Calculate",
  "应收": "Receivable",
  "name / vendor_key 必填": "Name / vendor_key are required",
  "已建费率(同渠道同国家的老 active 自动 supersede)": "Rate created (the previous active rate for the same channel + country was superseded automatically)",
  // 2026-09-24 供应商批量导入
  "批量导入": "Import",
  "批量导入供应商": "Import Suppliers",
  "供应商导入模板.xlsx": "Supplier_Import_Template.xlsx",
  "下载模板": "Download Template",
  "下载模板,按列填好(名称必填,编号留空会自动生成)": "Download the template and fill it in (Name is required; leave Code blank to auto-number)",
  "选择填好的 Excel,系统先检查一遍,不会马上导入": "Choose the filled-in Excel file — it is checked first, nothing is imported yet",
  "确认后只导入「新建」的行:已存在的供应商跳过不动,有错的行不导,改好再单独导一次": "On confirm only \"New\" rows are imported: existing suppliers are skipped, rows with errors are left out — fix them and import them again",
  "有错": "Error",
  "新建 {n}": "New {n}",
  "跳过 {n}": "Skipped {n}",
  "有错 {n}": "Errors {n}",
  "只看跳过 / 有错的行": "Only show skipped / error rows",
  "行号": "Row",
  "自动生成": "Auto",
  "重新检查": "Check Again",
  "导入 {n} 个供应商": "Import {n} Suppliers",
  "已导入 {n} 个供应商": "Imported {n} suppliers",
  "跳过 {n} 个": "{n} skipped",
  "{n} 行有错没导": "{n} rows with errors not imported",
  // 2026-10-09 集团内合同「一式两份」· 卖方会签
  "销售合同": "Sales contracts",
  "客户列表": "Customer list",
  "客户档案 · 集团内销售合同(一式两份 · 会签)": "Customer records · intra-group sales contracts (in duplicate · countersigned)",
  "兼集团内销售合同会签": "Also countersigns intra-group sales contracts",
  "设置": "Settings",
  "费用核票": "Expense invoice check",
  "审批人 = 核票人(会计)· 公司管理员也能核": "Approver = invoice checker (accountant) · admins can also check",
  "待我方会签": "Awaiting our countersignature",
  "已退回 · 买方修改中": "Returned · buyer revising",
  "我方已会签": "Countersigned by us",
  "我方已退回": "Returned by us",
  "历史补录 · 视为已双签": "Legacy record · treated as signed by both parties",
  "任一管理员": "Any admin",
  "确认会签「{title}」?": "Countersign \"{title}\"?",
  "会签后合同立即生效,合同价马上用于推单。系统会记录你的账号、时间、IP 和合同校验码 {hash}。":
    "Once countersigned, the contract takes effect immediately and its prices are used for order pushing. The system records your account, time, IP and the contract checksum {hash}.",
  "会签": "Countersign",
  "确认会签": "Confirm countersign",
  "已会签 · 合同生效": "Countersigned · contract active",
  "退回必须填理由": "A reason is required to return",
  "已退回买方": "Returned to buyer",
  "待我方会签 {n} 份": "{n} awaiting our countersignature",
  "搜合同号/标题": "Search contract no. / title",
  "本公司会签人:{name}(=「供应商合同」审批人)": "Our countersigner: {name} (= supplier-contract approver)",
  "集团内其它公司把本公司设为内部供应商时,它们的采购合同会出现在这里:同一份合同、双方各执一份。买方批准后需要本公司会签才生效。":
    "When another group company sets us as an internal supplier, its purchase contracts appear here: one contract, one copy for each party. After the buyer approves, it takes effect only once we countersign.",
  "客户(买方)": "Customer (buyer)",
  "待 {name} 会签": "Awaiting countersignature by {name}",
  "打印正本": "Print original",
  "付款条件": "Payment terms",
  "买方审批": "Buyer approval",
  "我方会签": "Our countersignature",
  "退回理由": "Return reason",
  "校验码": "Checksum",
  "合同明细 · 我方售价": "Contract lines · our selling prices",
  "共 {n} 行": "{n} lines",
  "找到 {n} 行": "{n} found",
  "搜产品编码 / 名称": "Search product code / name",
  "变更记录": "Change log",
  "退回买方": "Return to buyer",
  "必填 · 买方会看到": "Required · the buyer will see it",
  "待卖方会签": "Awaiting seller countersignature",
  "卖方已会签": "Countersigned by seller",
  "卖方已退回": "Returned by seller",
  "已批准 · 等「{name}」会签后生效": "Approved · takes effect once {name} countersigns",
  "集团内合同 · 批准后需卖方会签": "Intra-group contract · seller countersignature required after approval",
  "「{name}」会签后才生效,来货价那时才生成": "Takes effect only after {name} countersigns; supply prices are created then",
  "会签人 {name} · {time}": "Countersigned by {name} · {time}",
  "退回理由:{reason} · 改好后重新提交审批": "Return reason: {reason} · revise and resubmit for approval",
  "已暂停": "Paused",
} as Record<string, string>;
